"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var eventNames = {
  linkClicked: 'linkClicked',
  drawerOpened: 'drawerOpened',
  drawerClosed: 'drawerClosed',
  dropdownOpened: 'dropdownOpened',
  dropdownClosed: 'dropdownClosed',
  formFailed: 'formFailed',
  formSubmitted: 'formSubmitted',
  insuranceWhitepaperFormSubmitted: 'insuranceWhitepaperFormSubmitted',
  fleetWhitepaperFormSubmitted: 'fleetWhitepaperFormSubmitted',
  carSharingWhitepaperFormSubmitted: 'carSharingWhitepaperFormSubmitted',
  evChargingWhitepaperFormSubmitted: 'evChargingWhitepaperFormSubmitted',
  buildVsBuyFormSubmitted: 'buildVsBuyFormSubmitted',
  roadUsageChargeFormSubmitted: 'roadUsageChargeFormSubmitted',
  repairAndMaintenanceFormSubmitted: 'repairAndMaintenanceFormSubmitted',
  utilitiesFormSubmitted: 'utilitiesFormSubmitted',
  demoFormSubmitted: 'demoFormSubmitted',
  contactFormSubmitted: 'contactFormSubmitted',
  mailingListFormSubmitted: 'mailingListFormSubmitted',
  developerSignup: 'developerSignup',
  tabSelected: 'tabSelected',
  buttonClicked: 'buttonClicked',
  modalOpened: 'modalOpened',
  modalClosed: 'modalClosed',
  tooltipOpened: 'tooltipOpened',
  searchBarQueried: 'searchBarQueried',
  requestDemoButtonClicked: 'requestDemoButtonClicked',
  calendlyDemoModalOpened: 'calendlyDemoModalOpened',
  calendlyDemoProfilePageViewed: 'calendlyDemoProfilePageViewed',
  calendlyDemoEventTypeViewed: 'calendlyDemoEventTypeViewed',
  calendlyDemoTimeSelected: 'calendlyDemoTimeSelected',
  calendlyDemoRequestSubmitted: 'calendlyDemoRequestSubmitted',
  applicationLoaded: 'applicationLoaded',
  applicationActive: 'applicationActive',
  commandAi: 'commandAi'
};
var _default = eventNames;
exports["default"] = _default;